import { h } from "vue";
import { ElMessageBox } from "element-plus";
const options = {
  water: {
    show(form, formItems, allValid) {
      let { MARGIN_PAY_TYPE = [] } = form;
      let arr = ["工程担保公司出具的担保保函", "保险公司出具的投标保证保险", "银行保函", "电子保函"];
      return (
        MARGIN_PAY_TYPE.reduce((pre, cur) => {
          return pre || arr.indexOf(cur) >= 0;
        }, false) &&
        formItems.length &&
        allValid
      );
    },
    sign(form, call) {
      let isReportState = ["5"]; /*备案编号状态：1待审查、5审查通过、6审查不通过*/
      let { IS_REPORT, REVIEW_STATUS } = form;
      if (IS_REPORT && isReportState.indexOf(REVIEW_STATUS) === -1) {
        let tip = "空。";
        let tipMsg = "";
        switch (REVIEW_STATUS) {
          case "0":
            tip = "暂存。";
            break;
          case "1":
            tip = "待审查。";
            break;
          case "2":
            tip = "退回，不属于本部门监管的项目。";
            break;
          case "3":
            tip = "退回，备案材料不完整。";
            break;
          case "5":
            tip = "审查通过。";
            break;
          case "6":
            tip = "审查不通过。";
            break;
        }
        if (tip) {
          tipMsg = h("p", null, [
            h("span", null, "当前项目在行政监督平台备案状态为 "),
            h("span", { style: "color: red" }, tip),
            h("span", null, "状态为"),
            h("span", { style: "color: #13CE66" }, "审查通过"),
            h("span", null, "的项目可推送省网并在省网展示"),
            h("span", null, "建议待审查通过再发布项目"),
          ]);
        }
        ElMessageBox({
          title: "提示",
          type: "warning",
          message: tipMsg,
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        });
      } else {
        call && call();
      }
    },
  },
  house: {
    show(form, formItems, allValid) {
      let { MARGIN_PAY_TYPE = [] } = form
      let arr = ["工程担保公司出具的担保保函", "保险公司出具的投标保证保险", "银行保函"]
      return (
        MARGIN_PAY_TYPE.reduce((pre, cur) => {
          return pre || arr.indexOf(cur) >= 0
        }, false) &&
        formItems.length &&
        allValid
      )
    },
    sign(form, call) {
      call && call()
    }
  },
  traffic: {
    show(form, formItems, allValid, MARGIN_PAY_TYPE = []) {
      let arr = ["1", "4", "5"]
      return MARGIN_PAY_TYPE.reduce((pre, cur) => pre || arr.indexOf(cur) >= 0, false) && formItems.length && allValid
    },
    sign(form, call) {
      call && call()
    }
  }
}

export const config = options[__type__ || "house"]

export default {}
